import styled from "styled-components";


export const DownloadBtn = styled.button`
    background-color: transparent;
    border: none;
`;
